const getLeafItem = (str, separator = '>') => str.split(separator).slice(-1)[0];

const nestCount = (str, separator = '>') => str.split(separator).length

export  {
    getLeafItem,
    nestCount
};